export interface HelpNavigationItem {
    id: string;
    name: string;
    categoryId: string;
    category?: string;
    lastUpdatedById: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;
    isDeleted: boolean;    
}

export class HelpItem implements HelpNavigationItem {
    id: string;
    name: string;
    categoryId: string;
    category?: string;
    lastUpdatedById: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;
    isDeleted: boolean;
    uri: string;
    data: string;

    constructor() { }
}

export class HelpCategory implements HelpNavigationItem {
    id: string;
    name: string;
    readonly categoryId: string;
    get category() { return "Categories" }
    lastUpdatedById: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;
    isDeleted: boolean;

    constructor() {
        this.categoryId = "Categories";
    }
}

export class HelpNav implements HelpNavigationItem {
    id: string;
    name: string;
    categoryId: string;
    lastUpdatedById: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;
    isDeleted: boolean; 
    category: string;

    constructor(navItem: HelpNavigationItem, cat: HelpCategory) {
        this.id = navItem.id;
        this.name = navItem.name;
        this.lastUpdatedById = navItem.lastUpdatedById;
        this.lastUpdatedBy = navItem.lastUpdatedBy;
        this.lastUpdatedDate = navItem.lastUpdatedDate;
        this.isDeleted = navItem.isDeleted;
        this.categoryId = navItem.categoryId;
        this.category = (cat != null) ? cat.name : "Uncategorized";
    }
}

export interface HelpQuerySpec {
    id: string;
    categoryId: string;
    includeData: boolean;
}